<template>
    <v-container fill-height fluid grid-list-xl class="pl-3 pt-0">
        <v-layout wrap>
            <v-flex xs8>
                <v-card
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <v-layout row justify-space-between>
                        <v-layout column class="ma-1 px-3">
                            <v-card-title class="pb-2 pt-3" primary-title>
                                <div>
                                    <h3
                                        class="headline my-0 pt-2 pl-0"
                                        v-if="account && account.familyID"
                                    >
                                        Family ID:
                                        <router-link
                                            :to="{
                                                name: 'Account View',
                                                params: {
                                                    id: account.familyID,
                                                },
                                            }"
                                            >{{ account.familyID }}</router-link
                                        >
                                    </h3>
                                </div>
                            </v-card-title>
                            <v-card-text
                                class="mb-0 pb-0 pt-0"
                                v-if="account && account.familyID"
                            >
                                <div class="card-title font-weight-medium mb-0">
                                    {{ account.name }}
                                </div>
                                <div class="mb-4 ml-0">
                                    {{ account.nameH }}
                                </div>
                                <div class="ml-2 mt-4">
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Address:
                                        </div>
                                        <div>
                                            {{ account.busAddress1 }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Home:
                                        </div>
                                        <div>
                                            {{ account.homePhone }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Cell:
                                        </div>
                                        <div>
                                            {{ account.cellPhone }}
                                        </div>
                                    </v-layout>

                                    <v-divider class="pb-2"></v-divider>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Enrolled:
                                        </div>
                                        <div>
                                            {{ account.enrolled }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="mb-2"
                                        v-if="account.enrolledForSummer"
                                    >
                                        <div class="font-weight-medium mr-2">
                                            Enrolled For Summer:
                                        </div>
                                        <div>
                                            {{ account.enrolledForSummer }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Enrolled Date:
                                        </div>
                                        <div>
                                            {{ account.enrolledDate | time }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="mb-2"
                                        v-if="account.dcWeeks"
                                    >
                                        <div class="font-weight-medium mr-2">
                                            Summer Weeks:
                                        </div>
                                        <div>
                                            {{ account.dcWeeks }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Large Boxes:
                                        </div>
                                        <div>
                                            {{ account.largeBoxes }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Small Boxes:
                                        </div>
                                        <div>
                                            {{ account.smallBoxes }}
                                        </div>
                                    </v-layout>

                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Alert # 1:
                                        </div>
                                        <div>
                                            {{ account.sendAlertsTo }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Alert Type 1:
                                        </div>
                                        <div>
                                            {{ account.sendAlertsType }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="mb-2"
                                        v-if="account.alertNumber2"
                                    >
                                        <div class="font-weight-medium mr-2">
                                            Alert # 2:
                                        </div>
                                        <div>
                                            {{ account.alertNumber2 }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="mb-2"
                                        v-if="
                                            account.alertNumber2 &&
                                                account.alertType2
                                        "
                                    >
                                        <div class="font-weight-medium mr-2">
                                            Alert Type 2:
                                        </div>
                                        <div>
                                            {{ account.alertType2 }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="mb-2"
                                        v-if="account.alertNumber3"
                                    >
                                        <div class="font-weight-medium mr-2">
                                            Alert # 3:
                                        </div>
                                        <div>
                                            {{ account.alertNumber3 }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="mb-2"
                                        v-if="
                                            account.alertNumber3 &&
                                                account.alertType3
                                        "
                                    >
                                        <div class="font-weight-medium mr-2">
                                            Alert Type 3:
                                        </div>
                                        <div>
                                            {{ account.alertType3 }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Route Number:
                                        </div>
                                        <div>
                                            {{ account.routeNumber }}
                                        </div>
                                    </v-layout>
                                    <v-layout row class="mb-2">
                                        <div class="font-weight-medium mr-2">
                                            Route Sort:
                                        </div>
                                        <div>
                                            {{ account.routeSort }}
                                        </div>
                                    </v-layout>
                                    <v-layout
                                        row
                                        class="mb-2"
                                        v-if="account.boxNote"
                                    >
                                        <div class="font-weight-medium mr-2">
                                            Box Note:
                                        </div>
                                        <div>
                                            {{ account.boxNote }}
                                        </div>
                                    </v-layout>
                                </div>
                            </v-card-text>
                        </v-layout>
                    </v-layout>

                    <v-spacer></v-spacer>

                    <v-layout
                        align-end
                        justify-space-between
                        column
                        fill-height
                        class="mb-0 mr-2"
                    >
                        <v-btn
                            class="mt-0 mb-3 mr-1"
                            color="success"
                            small
                            dark
                            @click="openEditDialog"
                        >
                            Edit
                        </v-btn>
                    </v-layout>
                </v-card>

                <v-card
                    class="pa-3 mt-3"
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <v-tabs color="success" dark icons-and-text>
                        <v-tabs-slider color="#fff"></v-tabs-slider>

                        <v-tab href="#distributions">
                            Distributions ({{ distributions.length }})
                            <v-icon>mdi-truck-delivery</v-icon>
                        </v-tab>

                        <v-tab href="#feedback">
                            Feedback ({{ feedback.length }})
                            <v-icon>mdi-message-alert</v-icon>
                        </v-tab>

                        <v-tab href="#ivrcalls">
                            IVR Calls ({{ getIvrCallsCount() }})
                            <v-icon>mdi-phone</v-icon>
                        </v-tab>

                        <v-tab-item value="distributions">
                            <vue-good-table
                                class="distribution-list"
                                style="width: 100%;"
                                styleClass="vgt-table striped"
                                :columns="distributionColumns"
                                :rows="distributions"
                                :expandedOptions="{
                                    enabled: true,
                                    template: 'distribution-details',
                                }"
                                ref="grid"
                                :search-options="{
                                    enabled: false,
                                }"
                            >
                                <template slot="table-row" slot-scope="props">
                                    <span
                                        v-if="props.column.isIcon"
                                        class="px-0"
                                    >
                                        <v-icon
                                            class="px-0"
                                            dark
                                            :color="
                                                props.column.iconColor(
                                                    props.row[
                                                        props.column.field
                                                    ]
                                                )
                                            "
                                            >{{
                                                props.column.icon(
                                                    props.row[
                                                        props.column.field
                                                    ]
                                                )
                                            }}</v-icon
                                        >
                                    </span>
                                    <span v-else>
                                        {{
                                            props.formattedRow[
                                                props.column.field
                                            ]
                                        }}
                                    </span>
                                </template>
                                <template
                                    slot="expanded-row"
                                    slot-scope="props"
                                    class="pl-0"
                                >
                                    <distribution-details
                                        :scan="openScanBoxesDialog"
                                        class="pl-0"
                                        :distribution="props.row"
                                        :callNotifications="callNotifications"
                                        :smsNotifications="smsNotifications"
                                    ></distribution-details>
                                </template>
                            </vue-good-table>
                        </v-tab-item>
                        <v-tab-item value="feedback">
                            <account-feedback
                                :feedbackList="feedback"
                                :account="account"
                            ></account-feedback>
                        </v-tab-item>
                        <v-tab-item value="ivrcalls">
                            <food-distribution-ivr-calls
                                ref="ivrCalls"
                            ></food-distribution-ivr-calls>
                        </v-tab-item>
                    </v-tabs>
                </v-card>
            </v-flex>
            <v-flex xs4 class="pa-0 mt-2 pt-1">
                <v-card
                    v-if="siblings.length"
                    class="pb-3"
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <v-card-title class="headline pb-2">Siblings</v-card-title>
                    <v-layout row class="mx-3 mt-2 mb-2 font-weight-medium">
                        <div style="width: 300px">Name</div>
                        <div style="width: 25%">Grade</div>
                        <div style="width: 25%">Age</div>
                        <div style="width: 25%">DOB</div>
                    </v-layout>
                    <v-divider></v-divider>
                    <div v-for="(sibling, index) in siblings">
                        <v-layout row class="mx-3 my-3">
                            <!-- <div>{{ sibling.nameRecordingURL }}</div> -->
                            <audio
                                v-if="sibling.nameRecordingURL"
                                style="height: 25px; width: 300px;"
                                controls
                                class="mr-4"
                                :src="sibling.nameRecordingURL"
                            ></audio>
                            <div
                                v-if="!sibling.nameRecordingURL"
                                style="width: 300px;"
                            >
                                {{ sibling.name }}
                            </div>
                            <div style="width: 25%">{{ sibling.class }}</div>
                            <div style="width: 25%">{{ sibling.age }}</div>
                            <div style="width: 25%">
                                {{ sibling.dob | date }}
                            </div>
                        </v-layout>
                        <v-divider
                            class=""
                            v-if="index + 1 < siblings.length"
                            :key="index"
                        ></v-divider>
                    </div>
                </v-card>
                <v-card
                    class="pb-2"
                    v-bind:class="{ 'mt-3': siblings.length }"
                    v-if="
                        account && account.lastDistributionName && lastDelivery
                    "
                    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
                >
                    <v-card-title class="headline pb-2 mb-3"
                        >Last Scan</v-card-title
                    >
                    <v-layout row class="ml-3 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Distribution Name
                        </div>
                        <div>{{ lastDelivery.distributionName }}</div>
                    </v-layout>
                    <v-layout row class="ml-3 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Boxes
                        </div>
                        <div>
                            {{ getBoxesDetails() }}
                        </div>
                    </v-layout>
                    <v-layout row class="ml-3 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Last Scan
                        </div>
                        <div>
                            {{ lastDelivery.scannedAt | time }}
                        </div>
                    </v-layout>
                    <v-layout row class="ml-3 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Address
                        </div>
                        <div>
                            {{
                                lastDelivery.boxes[0].house +
                                    " " +
                                    lastDelivery.boxes[0].street
                            }}
                        </div>
                    </v-layout>
                    <v-layout
                        row
                        class="ml-3 mb-2"
                        v-if="getLastScanLocation()"
                    >
                        <div class="font-weight-medium mr-1 width-200">
                            Last Scan Location
                        </div>
                        <div>
                            {{ getLastScanLocation() }}
                        </div>
                    </v-layout>
                    <v-layout row class="ml-3 mb-2">
                        <div class="font-weight-medium mr-1 width-200">
                            Scheduled Delivery Date
                        </div>
                        <div>
                            {{
                                lastDelivery.boxes[0].scheduledDeliveryDate
                                    | date
                            }}
                        </div>
                    </v-layout>
                    <v-layout
                        row
                        class="ml-3 mb-2"
                        v-if="lastNotification && lastNotification.type"
                    >
                        <div class="font-weight-medium mr-1 width-200">
                            Notified By
                        </div>
                        <div>
                            {{ lastNotification.type }}
                        </div>
                    </v-layout>
                    <v-layout
                        row
                        class="ml-3 mb-2"
                        v-if="lastNotification && lastNotification.type"
                    >
                        <div class="font-weight-medium mr-1 width-200">
                            Notified At
                        </div>
                        <div>
                            {{ lastNotification.date | time }}
                        </div>
                    </v-layout>
                    <v-layout
                        row
                        class="ml-3 mb-2"
                        v-if="lastNotification && lastNotification.type"
                    >
                        <div class="font-weight-medium mr-1 width-200">
                            Notification #
                        </div>
                        <div>
                            {{ formatPhoneNumber(lastNotification.to) }}
                        </div>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog
            scrollable
            persistent
            v-model="updateFamilyDialog"
            max-width="650"
        >
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Family</v-card-title
                >
                <v-layout row>
                    <div class="mb-3" style="width: 50%">
                        <div>{{ accountToEdit.name }}</div>
                        <div>{{ accountToEdit.busAddress1 }}</div>
                        <div class="mt-2">
                            <span class="font-weight-medium pr-2"
                                >Large Boxes:</span
                            >
                            {{ accountToEdit.largeBoxes }}
                        </div>
                        <div>
                            <span class="font-weight-medium pr-2"
                                >Small Boxes:</span
                            >
                            {{ accountToEdit.smallBoxes }}
                        </div>
                    </div>
                    <div
                        class="mb-3 pa-2"
                        style="width: 50%; border: #4caf50 2px solid;"
                        v-if="accountToEdit.accountChanges"
                    >
                        <div class="headline">Account Changes</div>
                        <div class="mt-2">
                            <span class="font-weight-medium pr-2 width-200"
                                >Change Type:</span
                            >
                            {{ accountToEdit.accountChanges.change }}
                        </div>
                        <div>
                            <span class="font-weight-medium pr-2 width-200"
                                >Current Address:</span
                            >
                            {{ accountToEdit.accountChanges.currentAddress }}
                        </div>
                        <div
                            v-if="accountToEdit.accountChanges.previousAddress"
                        >
                            <span class="font-weight-medium pr-2 width-200"
                                >Previous Address:</span
                            >
                            {{ accountToEdit.accountChanges.previousAddress }}
                        </div>
                    </div>
                </v-layout>
                <div style="overflow-y: auto; height: 550px">
                    <v-text-field
                        class="mb-2"
                        hide-details
                        label="Route Number"
                        v-model="accountToEdit.routeNumber"
                    ></v-text-field>
                    <v-text-field
                        class="mb-2"
                        hide-details
                        label="Route Sort"
                        v-model="accountToEdit.routeSort"
                    ></v-text-field>
                    <v-text-field
                        class="mb-2"
                        hide-details
                        label="Label Batch"
                        v-model="accountToEdit.labelBatch"
                    ></v-text-field>
                    <v-text-field
                        class="mb-2"
                        hide-details
                        label="Box Note"
                        v-model="accountToEdit.boxNote"
                    ></v-text-field>
                    <div style="border: 2px solid #4caf50" class="pa-2">
                        <div class="title mb-2">Notification Numbers</div>
                        <v-layout row>
                            <v-text-field
                                class="mr-2 mt-0"
                                label="Alert #"
                                v-model="accountToEdit.sendAlertsTo"
                                ref="sendAlertsTo"
                                :rules="[rules.phoneNumber]"
                            ></v-text-field>
                            <v-select
                                class="mt-0"
                                hide-details
                                :items="['CALL', 'TEXT']"
                                label="Alert Type"
                                v-model="accountToEdit.sendAlertsType"
                            ></v-select>
                        </v-layout>
                        <v-layout row>
                            <v-text-field
                                class="mr-2 mt-0"
                                label="Alert #"
                                v-model="accountToEdit.alertNumber2"
                                ref="alertNumber2"
                                :rules="[rules.phoneNumber]"
                            ></v-text-field>
                            <v-select
                                class="mt-0"
                                hide-details
                                :items="['CALL', 'TEXT']"
                                label="Alert Type"
                                v-model="accountToEdit.alertType2"
                            ></v-select>
                        </v-layout>
                        <v-layout row>
                            <v-text-field
                                class="mr-2 mt-0"
                                label="Alert #"
                                v-model="accountToEdit.alertNumber3"
                                ref="alertNumber3"
                                :rules="[rules.phoneNumber]"
                            ></v-text-field>
                            <v-select
                                class="mt-0"
                                hide-details
                                :items="['CALL', 'TEXT']"
                                label="Alert Type"
                                v-model="accountToEdit.alertType3"
                            ></v-select>
                        </v-layout>
                    </div>

                    <v-radio-group
                        v-model="accountToEdit.enrolled"
                        row
                        class="mb-2 mt-3"
                        hide-details
                    >
                        <div class="width-200">Enrolled</div>
                        <v-radio
                            class="pr-2"
                            label="0"
                            value="0"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="pr-2"
                            label="1"
                            value="1"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class=""
                            label="2"
                            value="2"
                            color="success"
                        ></v-radio>
                    </v-radio-group>

                    <v-radio-group
                        v-model="accountToEdit.enrolledForSummer"
                        row
                        class="mb-4 mt-2"
                        hide-details
                    >
                        <div class="width-200">Enrolled For Summer</div>
                        <v-radio
                            class="pr-2"
                            label="0"
                            value="0"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="pr-2"
                            label="1"
                            value="1"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class=""
                            label="2"
                            value="2"
                            color="success"
                        ></v-radio>
                    </v-radio-group>
                    <div v-if="dayCampStudents.length">
                        <v-layout row class="font-weight-medium">
                            <div
                                style="min-width: 50px; max-width: 50px;"
                            ></div>
                            <div style="min-width: 200px;">Name</div>
                            <div style="min-width: 140px;">Dob</div>
                            <div style="min-width: 100px;">Class</div>
                            <div style="min-width: 50px;">Age</div>
                        </v-layout>
                        <v-divider class="pt-3 pb-1"></v-divider>
                    </div>
                    <div
                        v-if="dayCampStudents.length"
                        v-for="(student, index) in dayCampStudents"
                    >
                        <v-layout row>
                            <v-checkbox
                                style="max-width: 50px; min-width: 50px;"
                                hide-details
                                class="my-0 pt-0 pb-2"
                                color="success"
                                v-model="student.selected"
                            ></v-checkbox>
                            <div style="width: 200px;">
                                {{ student.engName }}
                            </div>
                            <div style="width: 140px;">
                                {{ student.dob | date }}
                            </div>
                            <div style="width: 100px;">{{ student.class }}</div>
                            <div style="width: 50px;">
                                {{ getAge(student.dob) }}
                            </div>
                        </v-layout>
                        <v-divider class="pt-3 pb-0"></v-divider>
                    </div>

                    <v-btn
                        v-if="
                            !accountToEdit &&
                                !accountToEdit.siblings &&
                                !accountToEdit.siblings.length
                        "
                        color="success"
                        @click="addSibling(accountToEdit.siblings)"
                        >Add Sibling</v-btn
                    >
                    <div
                        v-if="
                            accountToEdit &&
                                accountToEdit.siblings &&
                                accountToEdit.siblings.length
                        "
                    >
                        <div
                            v-for="(sibling,
                            index) in accountToEdit.siblings.filter(
                                (s) => !s.studentID
                            )"
                        >
                            <v-layout row>
                                <audio
                                    v-if="sibling.nameRecordingURL"
                                    style="height: 25px; width: 300px;"
                                    controls
                                    class="mt-2 mr-2"
                                    :src="sibling.nameRecordingURL"
                                ></audio>
                                <v-text-field
                                    style="width: 200px;"
                                    class="mr-2 mt-0 pt-0"
                                    label="Name"
                                    v-model="sibling.name"
                                ></v-text-field>
                                <!-- <v-text-field
                                    class="mt-0 pt-0 mr-2"
                                    label="Age"
                                    style="width: 50px;"
                                    type="number"
                                    ref="age"
                                    disabled
                                    :value="sibling.age"
                                ></v-text-field> -->
                                <v-menu
                                    v-model="sibling.datePickerMenu"
                                    :close-on-content-click="false"
                                    full-width
                                    class="pt-0 mt-0"
                                    offset-y
                                    max-width="290"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="sibling.dob"
                                            class="pt-0 mt-0"
                                            label="Date"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="sibling.dob"
                                        @change="siblingDobChanged(sibling)"
                                    ></v-date-picker>
                                </v-menu>
                                <v-btn
                                    class="mt-0"
                                    @click="addSibling(accountToEdit.siblings)"
                                    flat
                                    icon
                                    color="success"
                                >
                                    <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                                <v-btn
                                    class="mt-0"
                                    @click="
                                        removeSibling(
                                            accountToEdit.siblings,
                                            sibling
                                        )
                                    "
                                    flat
                                    icon
                                    color="#f55a4e"
                                >
                                    <v-icon>mdi-minus-circle-outline</v-icon>
                                </v-btn>
                            </v-layout>
                            <v-divider
                                class="pt-3 pb-1"
                                v-if="index + 1 < accountToEdit.siblings.length"
                                :key="index"
                            ></v-divider>
                        </div>
                    </div>
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateFamilyDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveFamily()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="scanBoxesDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Scan Boxes</v-card-title
                >
                <v-select
                    class="mb-0 mx-1"
                    label="Scan Type"
                    ref="scanType"
                    :rules="[rules.required]"
                    :items="scanBoxes.types"
                    v-model="scanBoxes.scanType"
                ></v-select>
                <v-checkbox
                    v-if="scanBoxes.scanType == 'Delivered'"
                    class="my-0"
                    label="Dont Alert"
                    color="success"
                    v-model="scanBoxes.dontAlert"
                ></v-checkbox>
                <v-card-actions class="mr-0 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="scanBoxesDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveScan"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import { groupBy, formatPhoneNumber } from "../../utils/helpers.js";
import distributionDetails from "../components/DistributionDetails.vue";
import accountFeedback from "./Components/AccountFeedback.vue";
import foodDistributionIvrCalls from "./Components/FoodDistributionIvrCalls.vue";
import moment from "moment";

export default {
    components: {
        accountFeedback,
        foodDistributionIvrCalls,
    },
    data: () => ({
        account: null,
        updateFamilyDialog: false,
        accountToEdit: {
            siblings: [],
        },
        dayCampStudents: [],
        processing: false,
        siblings: [],
        boxes: [],
        scans: [],
        feedback: [],
        distributions: [],
        lastDelivery: "",
        lastNotification: "",
        scanBoxesDialog: false,
        boxesToScan: [],
        callNotifications: [],
        smsNotifications: [],

        scanBoxes: {
            scanType: "Delivered",
            types: ["Delivered", "NotDelivered", "Delete"],
            dontAlert: false,
        },

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
            phoneNumber: (v) => {
                return (
                    !v ||
                    ([10, 11].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Phone Number"
                );
            },
        },

        distributionColumns: [
            {
                sortable: true,
                field: "completed",
                hidden: false,
                isIcon: true,
                icon: (value, row) => {
                    if (!value) return "mdi-clock";

                    return "mdi-check-circle";
                },
                iconColor: (value, row) => {
                    if (!value) return "#fdb400";

                    return "success";
                },
            },
            {
                sortable: false,
                label: "Distribution Name",
                field: "distributionName",
                hidden: false,
            },
            {
                sortable: true,
                label: "Completed At",
                field: "scannedAt",
                hidden: false,
                type: "date",
                dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
            },
            {
                sortable: true,
                label: "Boxes",
                field: "boxesCount",
                hidden: false,
                type: "number",
            },
            {
                sortable: false,
                label: "Completed",
                field: "completed",
                type: "boolean",
                formatFn: (value) => (value ? "Yes" : "No"),
                hidden: false,
            },
        ],
    }),
    async created() {
        await this.loadAccount();
        this.loadBoxesAndScans();
    },
    methods: {
        async loadAccount() {
            const account = await this.$http.get(
                "api/foodDistributionAccountInfo/getAccountInfo?accountID=" +
                    this.$route.params.id
            );

            const siblings = await this.$http.get(
                "api/FoodDistributionAccountInfo/GetSiblings?callUUID=" +
                    account.callUUID
            );

            this.account = account;
            this.siblings = siblings;
        },
        async loadBoxesAndScans() {
            const response = await this.$http.get(
                "api/foodDistributionAccountInfo/getAccountDetails?accountID=" +
                    this.$route.params.id
            );

            this.boxes = response.boxes;
            this.scans = response.scans;
            this.feedback = response.feedback;
            this.callNotifications = response.callNotifications;
            this.smsNotifications = response.smsNotifications;

            const group = groupBy(this.boxes, "distributionID");

            this.distributions = Object.keys(group)
                .map((key) => {
                    const box = group[key][0];

                    const scanDates = group[key].map((b) => {
                        return b.scanDate ? new Date(b.scanDate) : null;
                    });
                    const scannedAt = new Date(Math.max.apply(null, scanDates));

                    const boxes = group[key].map((b) => {
                        b.scans = this.scans
                            .filter((s) => s.boxID == b.boxID)
                            .sort((a, b) => {
                                if (Date.parse(a.date) > Date.parse(b.date))
                                    return -1;
                                if (Date.parse(a.date) < Date.parse(b.date))
                                    return 1;
                                return 0;
                            });

                        return b;
                    });

                    return {
                        distributionID: key,
                        distributionName: box.distributionName,
                        scannedAt:
                            scanDates.length && scanDates[0] ? scannedAt : null,
                        notifications: this.getNotifications(boxes),
                        completed: group[key].every(
                            (b) => b.status == "DELIVERED"
                        ),
                        boxes: boxes,
                        boxesCount: boxes.length,
                        createdAt: box.dateCreated,
                    };
                })
                .sort((a, b) => {
                    if (Date.parse(a.createdAt) > Date.parse(b.createdAt))
                        return -1;
                    if (Date.parse(a.createdAt) < Date.parse(b.createdAt))
                        return 1;
                    return 0;
                });

            this.lastDelivery = this.getLastDeliveredDistribution();
            this.lastNotification = this.getLastNotification(response);
        },
        getNotifications(boxes) {
            if (!boxes.some((b) => b.alertedDate)) return [];

            const alertedDate = boxes.find((b) => b.alertedDate).alertedDate;
            const start = moment(alertedDate).subtract(1, "days");
            const end = moment(alertedDate).add(1, "days");

            const calls = this.callNotifications
                .filter((n) => moment(n.date) > start && moment(n.date) < end)
                .map((call) => {
                    call.type = "CALL";

                    return call;
                })
                .sort((a, b) => {
                    if (Date.parse(a.date) > Date.parse(b.date)) return -1;
                    if (Date.parse(a.date) < Date.parse(b.date)) return 1;

                    return 0;
                });

            const messages = this.smsNotifications
                .filter(
                    (n) =>
                        moment(n.dateTime) > start && moment(n.dateTime) < end
                )
                .map((message) => {
                    message.date = message.dateTime;
                    message.type = "TEXT";

                    return message;
                })
                .sort((a, b) => {
                    if (Date.parse(a.date) > Date.parse(b.date)) return -1;
                    if (Date.parse(a.date) < Date.parse(b.date)) return 1;

                    return 0;
                });

            return calls.concat(messages);
        },
        getSettingType(type) {
            return type == "TEXT" ? 2 : 1;
        },
        fixPhoneNumber(value) {
            if (!value) return "";

            let number = value.trim().replace(/\D/g, "");

            number = number.length == 10 ? "1" + number : number;

            return number;
        },
        getLastNotification(response) {
            if ((!response.sms && !response.call) || !this.lastDelivery) return;

            const notifications = [];

            if (response.sms) {
                response.sms.type = "TEXT";
                response.sms.date = response.sms.dateTime;

                notifications.push(response.sms);
            }

            if (response.call) {
                response.call.type = "CALL";

                notifications.push(response.call);
            }

            const start = moment(this.lastDelivery.scannedAt).subtract(
                1,
                "hours"
            );
            const end = moment(this.lastDelivery.scannedAt).add(3, "days");

            const sorted = notifications
                .filter((n) => moment(n.date) > start && moment(n.date) < end)
                .sort((a, b) => {
                    if (Date.parse(a.date) > Date.parse(b.date)) return -1;
                    if (Date.parse(a.date) < Date.parse(b.date)) return 1;
                    return 0;
                });

            return sorted.length ? sorted[0] : "";
        },
        getLastDeliveredDistribution() {
            const distribution = this.distributions.find((d) =>
                d.boxes.some((b) => b.status == "DELIVERED")
            );

            return distribution;
        },
        getLastScan() {
            if (!this.distributions.length) return;

            const distribution = this.distributions[0];

            const scans = this.scans
                .filter((s) => s.distributionID == distribution.distributionID)
                .sort((a, b) => {
                    if (Date.parse(a.date) > Date.parse(b.date)) return -1;
                    if (Date.parse(a.date) < Date.parse(b.date)) return 1;
                    return 0;
                });

            return scans.length ? scans[0] : "";
        },
        getBoxesDetails() {
            if (!this.lastDelivery || !this.lastDelivery.boxes) return;

            if (this.lastDelivery.boxes.length == 1)
                return "1 Box - Size " + this.lastDelivery.boxes[0].boxSize;

            if (
                this.lastDelivery.boxes.every(
                    (b) => b.boxSize == this.lastDelivery.boxes[0].boxSize
                )
            )
                return "2 Boxes - Size " + this.lastDelivery.boxes[0].boxSize;

            return (
                "2 Boxes - Size " +
                this.lastDelivery.boxes[0].boxSize +
                " & Size " +
                this.lastDelivery.boxes[1].boxSize
            );
        },
        getLastScanLocation() {
            if (!this.lastDelivery.distributionID) return "";

            const scans = this.lastDelivery.boxes
                .map((b) => b.scans)
                .flat()
                .sort((a, b) => {
                    if (Date.parse(a.date) > Date.parse(b.date)) return -1;
                    if (Date.parse(a.date) < Date.parse(b.date)) return 1;
                    return 0;
                });

            return scans.length ? scans[0].gpsAddress : "";
        },
        openScanBoxesDialog(box) {
            this.scanBoxesDialog = true;
            this.boxesToScan = JSON.parse(JSON.stringify([box]));
        },
        async saveScan() {
            if (!this.$refs.scanType.validate(true)) return;

            try {
                const ids = this.boxesToScan.map((s) => s.boxID);

                this.processing = true;

                await this.$http.post("api/foodDistributionScans/scanBoxes", {
                    boxIDs: ids,
                    user: this.$store.state.authentication.user,
                    scanType: this.scanBoxes.scanType,
                    dontAlert:
                        this.scanBoxes.scanType == "Delivered"
                            ? this.scanBoxes.dontAlert
                            : false,
                });

                this.processing = false;
                this.scanBoxesDialog = false;

                this.$notify({
                    group: "notification",
                    text: ids.length + " Boxes Scanned",
                    type: "success",
                });

                this.loadAccount();
                this.loadBoxesAndScans();
            } catch (e) {
                this.processing = false;
            }
        },
        async openEditDialog() {
            this.accountToEdit = JSON.parse(JSON.stringify(this.account));

            const accountChanges = await this.$http.get(
                "api/FoodDistributionAccountInfo/getAccountChanges?accountID=" +
                    this.accountToEdit.familyID
            );

            this.accountToEdit.accountChanges = accountChanges;
            this.accountToEdit.enrolled =
                this.accountToEdit.enrolled.toString() || "0";
            this.accountToEdit.enrolledForSummer = this.accountToEdit
                .enrolledForSummer
                ? this.accountToEdit.enrolledForSummer.toString()
                : "0";
            this.accountToEdit.isEnrolled = this.accountToEdit.enrolled == 1;

            const dayCampStudents = await this.$http.get(
                "api/FoodDistributionAccountInfo/GetDayCampStudents?accountID=" +
                    this.accountToEdit.familyID
            );

            this.dayCampStudents = dayCampStudents.map((student) => {
                student.selected = this.siblings.some(
                    (s) => s.studentID == student.studentID
                );

                return student;
            });

            this.accountToEdit.siblings = JSON.parse(
                JSON.stringify(this.siblings)
            ).map((sibling) => {
                sibling.dob = new Date(moment(sibling.dob))
                    .toISOString()
                    .substr(0, 10);

                sibling.datePickerMenu = false;

                if (sibling.studentID) {
                    const dayCampStudent = dayCampStudents.find(
                        (d) => d.studentID == sibling.studentID
                    );

                    sibling.selected = true;
                    sibling.class = dayCampStudent ? dayCampStudent.class : "";
                }

                return sibling;
            });

            this.updateFamilyDialog = true;
        },
        siblingDobChanged(sibling) {
            sibling.age = this.getAge(sibling.dob);
        },
        getAge(birthDate) {
            if (typeof birthDate == "string") {
                birthDate = new Date(birthDate);
            }

            var today = new Date();
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        },
        formatPhoneNumber(value) {
            return formatPhoneNumber(value);
        },
        addSibling(siblings) {
            if (!siblings) {
                siblings = [];
            }
            siblings.push({
                id: 0,
                familyID: this.accountToEdit.familyID,
                nameRecordingURL: "",
                age: "",
                callUUID: this.accountToEdit.callUUID,
                name: "",
                dob: "",
            });

            this.$forceUpdate();
        },
        removeSibling(siblings, sibling) {
            const index = siblings.indexOf(sibling);
            siblings.splice(index, 1);
            this.$forceUpdate();
        },
        addNotificationSetting(settings) {
            if (!settings) {
                settings = [];
            }
            settings.push({
                id: 0,
                familyID: this.accountToEdit.familyID,
                number: "",
                type: "CALL",
            });

            this.$forceUpdate();
        },
        removeNotificationSetting(settings, index) {
            settings.splice(index, 1);

            this.$forceUpdate();
        },
        validateNotificationSettings() {
            const alert1 =
                this.fixPhoneNumber(this.accountToEdit.sendAlertsTo) +
                "|" +
                this.accountToEdit.sendAlertsType;
            const alert2 =
                this.fixPhoneNumber(this.accountToEdit.alertNumber2) +
                "|" +
                this.accountToEdit.alertType2;
            const alert3 =
                this.fixPhoneNumber(this.accountToEdit.alertNumber3) +
                "|" +
                this.accountToEdit.alertType3;

            if (
                this.fixPhoneNumber(this.accountToEdit.sendAlertsTo) &&
                (alert1 == alert2 || alert1 == alert3)
            )
                return false;
            if (
                this.fixPhoneNumber(this.accountToEdit.alertNumber2) &&
                (alert2 == alert1 || alert2 == alert3)
            )
                return false;
            if (
                this.fixPhoneNumber(this.accountToEdit.alertNumber3) &&
                (alert3 == alert2 || alert3 == alert1)
            )
                return false;

            return true;
        },
        getSiblings() {
            const nonUta = this.accountToEdit.siblings.filter(
                (s) => !s.studentID
            );

            const uta = this.dayCampStudents.filter((s) => s.selected);

            const utaSiblings = uta.map((student) => {
                const sibling = this.accountToEdit.siblings.find(
                    (s) => s.studentID == student.studentID
                );

                if (sibling) return sibling;

                return {
                    name: student.engName,
                    familyID: this.accountToEdit.familyID,
                    studentID: student.studentID,
                    dob: student.dob,
                    age: this.getAge(student.dob),
                    isEnrolled: 1,
                };
            });

            return nonUta.concat(utaSiblings);
        },
        async saveFamily() {
            if (
                !this.$refs.sendAlertsTo.validate(true) ||
                !this.$refs.alertNumber2.validate(true) ||
                !this.$refs.alertNumber3.validate(true)
            )
                return;

            if (!this.validateNotificationSettings()) {
                this.$notify({
                    group: "notification",
                    text: "Please remove duplicate phone numbers",
                    type: "error",
                });

                return;
            }

            try {
                await this.$http.post(
                    "api/foodDistributionAccountInfo/updateFamily",
                    {
                        familyID: this.accountToEdit.familyID,
                        siblings: this.getSiblings(),
                        routeNumber: this.accountToEdit.routeNumber,
                        routeSort: this.accountToEdit.routeSort,
                        labelBatch: this.accountToEdit.labelBatch,
                        boxNote: this.accountToEdit.boxNote,
                        enrolled: +this.accountToEdit.enrolled,
                        enrolledForSummer: +this.accountToEdit
                            .enrolledForSummer,
                        user: this.$store.state.authentication.user,
                        sendAlertsTo: this.fixPhoneNumber(
                            this.accountToEdit.sendAlertsTo
                        ),
                        sendAlertsType:
                            this.accountToEdit.sendAlertsType == "TEXT" ? 2 : 1,
                        alertNumber2: this.fixPhoneNumber(
                            this.accountToEdit.alertNumber2
                        ),
                        alertType2:
                            this.accountToEdit.alertType2 == "TEXT" ? 2 : 1,
                        alertNumber3: this.fixPhoneNumber(
                            this.accountToEdit.alertNumber3
                        ),
                        alertType3:
                            this.accountToEdit.alertType3 == "TEXT" ? 2 : 1,
                    }
                );

                this.$notify({
                    group: "notification",
                    text: "Family Saved",
                    type: "success",
                });

                this.updateFamilyDialog = false;

                await this.loadAccount();
                this.loadBoxesAndScans();
            } catch (e) {}
        },
        getGpsAddress(location) {
            const src =
                "https://maps.google.com/maps?q=google&t=&z=15&ie=UTF8&iwloc=near&key=AIzaSyCtYeCL8HkqlMKJh6g6jcDvoH60-woVbDE&output=embed&q=";

            return src + location + ",Brooklyn+NY";
        },
        getIvrCallsCount() {
            if (this.$refs && this.$refs.ivrCalls)
                return this.$refs.ivrCalls.getCalls().length;

            return 0;
        },
    },
};
</script>
<style>
.v-expansion-panel__header {
    height: 63px;
}
.website-link-text {
    color: rgb(32, 166, 237);
    display: inline-block;
    word-wrap: break-word;
    width: 100%;
}
.distribution-list {
    border: 1px solid #ddd !important;
}
</style>
